import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from '../../../../../constants/symbols';

export const Header = () => (
  <UIText1>
    Не покажем кадастровый номер и{NBSP}точный адрес в{NBSP}блоке Росреестра
  </UIText1>
);
